import { type PropsWithChildren, ReactNode } from 'react'
import { cn } from '../../../utils'

export interface BorderedBoxProps extends PropsWithChildren {
  footer?: ReactNode
  className?: string
  grayOut?: boolean
  'data-testid': string
}

export default function BorderedBox({
  children,
  footer,
  className,
  grayOut,
  'data-testid': testId
}: Readonly<BorderedBoxProps>) {
  return (
    <>
      {grayOut && (
        <div
          className="absolute z-30 inset-0 bg-white/50 dark:bg-cool-gray-800/65 pointer-events-none"
          data-testid={`${testId}-gray-out-overlay`}
        />
      )}
      <div
        className={cn(
          'border border-cool-gray-200 px-1 py-1 rounded-xl',
          className
        )}
        data-testid={testId}
      >
        {children}
        {footer && (
          <div
            className="border-t border-cool-gray-200 mt-0.75 pt-0.5 -mb-0.25"
            data-testid={`${testId}-footer`}
          >
            {footer}
          </div>
        )}
      </div>
    </>
  )
}
